import Vue from 'vue'
import '@/plugins/axios'
import { _axios } from '@/plugins/axios'

import Vuelidate from 'vuelidate'

import App from '@/App.vue'

import router from '@/router/router'
import store from '@/store'
import i18n from '@/plugins/i18n'

import VueCasAuthentication from 'vue-cas-authentication'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import vuetify from '@/plugins/vuetify'
import UIcon from '@/plugins/unistra/UIcon'

import RichTextEditor from 'rich-text-editor-vuetify'
import CustomSelect from '@/components/general/CustomComponents/CustomSelect'

Vue.use(RichTextEditor)

Vue.use(Vuelidate)

Vue.use(VueCasAuthentication, {
  router,
  axios: _axios,
  options: {
    authCasLogoutUrl: 'cas_authentication_logout',
    appIsAllAuth: true,
    jwtServerUrl: process.env.VUE_APP_JWT_URL,
  },
})

if (process.env.VUE_APP_DEPLOYMENT_ENV !== 'dev') {
  Sentry.init({
    dsn: 'https://7f24e65de3d846da96773ff9c8d8eb4b@sentry.app.unistra.fr/3',
    environment: process.env.VUE_APP_DEPLOYMENT_ENV,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
}

Vue.config.productionTip = false

Vue.component('u-icon', UIcon)
Vue.component('u-select', CustomSelect)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app_air')
